import styled from "styled-components";
import { ClientSettingsDropdownSelectedDefaultBox } from "./client-settings-dropdown-selected.default.box";

export const ClientSettingsDropdownSelectedCasino777Box = styled(ClientSettingsDropdownSelectedDefaultBox)`
    color: ${({theme}) => theme.colors.moneyColor};
`